import './HText.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage, TextModule } from '~/schemes';
import { VerticalSpacing } from '~/plugins/gf-api/client/@types';

export const HText = tsx.component({
  name: 'HText',
  functional: true,

  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<TextModule['properties'], AvailableLanguage>
      >,
      required: true,
    },
    verticalSpacing: {
      type: String as PropType<VerticalSpacing>,
      required: false,
    },
  },

  render(h, { props }): VNode {
    const verticalSpacingClassName = props.verticalSpacing
      ? `v-text-module-vertical-spacing--${props.verticalSpacing}`
      : '';
    return (
      <div
        v-wysiwyg={props.value.text}
        class={[
          'h-container',
          `v-text-module`,
          `v-text-module-align--${props.value.align}`,
          // @memo フォントサイズの指定は今実装していないので、サイズ調整ツール等を導入することになったら使用する
          // `v-text-module--${props.value.size}`,
          verticalSpacingClassName,
        ]}></div>
    );
  },
});
